/** 시흥산업진흥원(ENT_CD=200) 계정마스터. aaccmst.xlsx 내부코드=ACC_UPP_CD, ACC_DCR_GB는 aslpviw 샘플·계정성격으로 보완 */
export default [
  {
    "ENT_CD": "200",
    "ACC_CD": "1",
    "ACC_NM": "자산",
    "ACC_FNM": "자 산",
    "ACC_UPP_CD": "1",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "10",
    "ACC_NM": "유동자산",
    "ACC_FNM": "I.  유    동     자    산",
    "ACC_UPP_CD": "11",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "100",
    "ACC_NM": "당좌자산",
    "ACC_FNM": "(1)  당   좌    자   산",
    "ACC_UPP_CD": "111",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "10100",
    "ACC_NM": "현금",
    "ACC_FNM": "현금",
    "ACC_UPP_CD": "111-01",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "10300",
    "ACC_NM": "보통예금",
    "ACC_FNM": "보통예금",
    "ACC_UPP_CD": "111-02",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "10500",
    "ACC_NM": "정기예.적금",
    "ACC_FNM": "정기예.적금",
    "ACC_UPP_CD": "111-03",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "11600",
    "ACC_NM": "미수수익",
    "ACC_FNM": "미   수   수    익",
    "ACC_UPP_CD": "111-16",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "12000",
    "ACC_NM": "미수금",
    "ACC_FNM": "미        수        금",
    "ACC_UPP_CD": "111-20",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "13100",
    "ACC_NM": "선급금",
    "ACC_FNM": "선      급       금",
    "ACC_UPP_CD": "111-31",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "13300",
    "ACC_NM": "선급비용",
    "ACC_FNM": "선   급   비   용",
    "ACC_UPP_CD": "111-33",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "13500",
    "ACC_NM": "부가세대급금",
    "ACC_FNM": "부  가  세  대  급  금",
    "ACC_UPP_CD": "111-35",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "13600",
    "ACC_NM": "선납세금",
    "ACC_FNM": "선    납      세    금",
    "ACC_UPP_CD": "111-36",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "13601",
    "ACC_NM": "선납법인세",
    "ACC_FNM": "선납법인세",
    "ACC_UPP_CD": "111-36-01",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "13602",
    "ACC_NM": "선납지방세",
    "ACC_FNM": "선납지방세",
    "ACC_UPP_CD": "111-36-02",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "146",
    "ACC_NM": "재고자산",
    "ACC_FNM": "(2)  재   고    자   산",
    "ACC_UPP_CD": "112",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "17",
    "ACC_NM": "비유동자산",
    "ACC_FNM": "Ⅱ. 비    유   동  자  산",
    "ACC_UPP_CD": "12",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "171",
    "ACC_NM": "투자자산",
    "ACC_FNM": "(1)  투   자    자   산",
    "ACC_UPP_CD": "121",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "19100",
    "ACC_NM": "지분법적용주식",
    "ACC_FNM": "기 본  재 산  예 치 금",
    "ACC_UPP_CD": "121-91",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "19600",
    "ACC_NM": "퇴직연금자산",
    "ACC_FNM": "퇴 직 연 금 자 산",
    "ACC_UPP_CD": "121-96",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "19700",
    "ACC_NM": "퇴직연금",
    "ACC_FNM": "퇴직연금",
    "ACC_UPP_CD": "121-97",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "19800",
    "ACC_NM": "퇴직연금운용자산",
    "ACC_FNM": "퇴직연금 운용 자산",
    "ACC_UPP_CD": "121-98",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "19900",
    "ACC_NM": "수입보증금",
    "ACC_FNM": "수입보증금",
    "ACC_UPP_CD": "121-99",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "201",
    "ACC_NM": "유형자산",
    "ACC_FNM": "(2)  유   형    자   산",
    "ACC_UPP_CD": "122",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "20100",
    "ACC_NM": "토지",
    "ACC_FNM": "토          지",
    "ACC_UPP_CD": "122-01",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "22100",
    "ACC_NM": "국고보조금토지",
    "ACC_FNM": "국고보조금토지",
    "ACC_UPP_CD": "122-02",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "20200",
    "ACC_NM": "건물",
    "ACC_FNM": "건             물",
    "ACC_UPP_CD": "122-03",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "22000",
    "ACC_NM": "국고보조금건물",
    "ACC_FNM": "국고보조금건물",
    "ACC_UPP_CD": "122-04",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "20300",
    "ACC_NM": "감가상각누계액건물",
    "ACC_FNM": "감가상각누계액",
    "ACC_UPP_CD": "122-05",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "20600",
    "ACC_NM": "기계장비",
    "ACC_FNM": "기계장비",
    "ACC_UPP_CD": "122-06",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "22300",
    "ACC_NM": "국고보조금기계장비",
    "ACC_FNM": "국고보조금기계장비",
    "ACC_UPP_CD": "122-07",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "20700",
    "ACC_NM": "감가상각누계액기계장비",
    "ACC_FNM": "감가상각누계액기계장비",
    "ACC_UPP_CD": "122-08",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "20800",
    "ACC_NM": "차량운반구",
    "ACC_FNM": "차   량   운   반   구",
    "ACC_UPP_CD": "122-09",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "20900",
    "ACC_NM": "차량운반상각누계액",
    "ACC_FNM": "감  가  상 각 누 계 액",
    "ACC_UPP_CD": "122-10",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "21200",
    "ACC_NM": "비품",
    "ACC_FNM": "비                  품",
    "ACC_UPP_CD": "122-11",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "22200",
    "ACC_NM": "국고보조금비품",
    "ACC_FNM": "국고보조금비품",
    "ACC_UPP_CD": "122-12",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "21300",
    "ACC_NM": "비품감가상각누계액",
    "ACC_FNM": "감  가  상 각 누 계 액",
    "ACC_UPP_CD": "122-13",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "231",
    "ACC_NM": "무형자산",
    "ACC_FNM": "(3)  무   형    자   산",
    "ACC_UPP_CD": "123",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "24000",
    "ACC_NM": "소프트웨어",
    "ACC_FNM": "소   프   트   웨   어",
    "ACC_UPP_CD": "123-01",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "24100",
    "ACC_NM": "국고보조금소프트웨어",
    "ACC_FNM": "국고보조금소프트웨어",
    "ACC_UPP_CD": "123-02",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "23700",
    "ACC_NM": "상표권",
    "ACC_FNM": "상        표        권",
    "ACC_UPP_CD": "123-03",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "181",
    "ACC_NM": "기타비유동자산",
    "ACC_FNM": "(4)기 타 비 유 동 자 산",
    "ACC_UPP_CD": "124",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "18800",
    "ACC_NM": "임차보증금",
    "ACC_FNM": "임   차   보   증   금",
    "ACC_UPP_CD": "124-88",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "19000",
    "ACC_NM": "기타보증금",
    "ACC_FNM": "기   타   보   증   금",
    "ACC_UPP_CD": "124-90",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "199",
    "ACC_NM": "자산총계",
    "ACC_FNM": "자 산 총 계",
    "ACC_UPP_CD": "1Y",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "2",
    "ACC_NM": "부채",
    "ACC_FNM": "부                       채",
    "ACC_UPP_CD": "2",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25",
    "ACC_NM": "유동부채",
    "ACC_FNM": "유 동 부 채",
    "ACC_UPP_CD": "21",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "251",
    "ACC_NM": "유동부채",
    "ACC_FNM": "I.  유    동     부    채",
    "ACC_UPP_CD": "210",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25200",
    "ACC_NM": "미지급금(카드)",
    "ACC_FNM": "미 지 급 금 ( 카 드 )",
    "ACC_UPP_CD": "210-52",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25300",
    "ACC_NM": "미지급금",
    "ACC_FNM": "미    지      급    금",
    "ACC_UPP_CD": "210-53",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25400",
    "ACC_NM": "예수금",
    "ACC_FNM": "예        수        금",
    "ACC_UPP_CD": "210-54",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25401",
    "ACC_NM": "시흥창업센터예수금",
    "ACC_FNM": "시흥창업센터예수금",
    "ACC_UPP_CD": "210-54-01",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25403",
    "ACC_NM": "예수금(건강보험)",
    "ACC_FNM": "예수금(건강보험)",
    "ACC_UPP_CD": "210-54-02",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25404",
    "ACC_NM": "예수금(고용보험)",
    "ACC_FNM": "예수금(고용보험)",
    "ACC_UPP_CD": "210-54-03",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25405",
    "ACC_NM": "예수금(장기요양)",
    "ACC_FNM": "예수금(장기요양)",
    "ACC_UPP_CD": "210-54-04",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25406",
    "ACC_NM": "예수금(소득세)",
    "ACC_FNM": "예수금(소득세)",
    "ACC_UPP_CD": "210-54-05",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25407",
    "ACC_NM": "예수금(지방소득세)",
    "ACC_FNM": "예수금(지방소득세)",
    "ACC_UPP_CD": "210-54-06",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25408",
    "ACC_NM": "예수금(기타소득)",
    "ACC_FNM": "예수금(기타소득)",
    "ACC_UPP_CD": "210-54-07",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25499",
    "ACC_NM": "예수금(기타)",
    "ACC_FNM": "예수금(기타)",
    "ACC_UPP_CD": "210-54-08",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25500",
    "ACC_NM": "부가세예수금",
    "ACC_FNM": "부   가   세   예   수   금",
    "ACC_UPP_CD": "210-55",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "25900",
    "ACC_NM": "선수금",
    "ACC_FNM": "선      수      금",
    "ACC_UPP_CD": "210-59",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "26200",
    "ACC_NM": "미지급비용",
    "ACC_FNM": "미   지   급   비   용",
    "ACC_UPP_CD": "210-62",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "27300",
    "ACC_NM": "국도비미지급금",
    "ACC_FNM": "국도비미지급금",
    "ACC_UPP_CD": "210-73",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "29",
    "ACC_NM": "비유동부채",
    "ACC_FNM": "비 유 동 부 채",
    "ACC_UPP_CD": "22",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "291",
    "ACC_NM": "비유동부채",
    "ACC_FNM": "Ⅱ. 비    유   동  부  채",
    "ACC_UPP_CD": "220",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "29400",
    "ACC_NM": "임대보증금",
    "ACC_FNM": "임   대   보   증   금",
    "ACC_UPP_CD": "220-04",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "29500",
    "ACC_NM": "퇴직급여충당금",
    "ACC_FNM": "퇴직  급여  충 당 금",
    "ACC_UPP_CD": "220-05",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "29600",
    "ACC_NM": "국민연금전환금",
    "ACC_FNM": "국 민 연 금 전 환 금",
    "ACC_UPP_CD": "220-06",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "29700",
    "ACC_NM": "퇴직연금",
    "ACC_FNM": "퇴 직 연 금",
    "ACC_UPP_CD": "220-07",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "30600",
    "ACC_NM": "장기수선충당금",
    "ACC_FNM": "장기수선충당금",
    "ACC_UPP_CD": "220-08",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "31100",
    "ACC_NM": "고유목적사업준비금",
    "ACC_FNM": "고유 목적  사업 준비금",
    "ACC_UPP_CD": "220-11",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "329",
    "ACC_NM": "부채총계",
    "ACC_FNM": "부      채       총      계",
    "ACC_UPP_CD": "2Y",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "3",
    "ACC_NM": "자본",
    "ACC_FNM": "자                       본",
    "ACC_UPP_CD": "3",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "331",
    "ACC_NM": "자본금",
    "ACC_FNM": "I.  자       본        금",
    "ACC_UPP_CD": "31",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "33100",
    "ACC_NM": "기본순자산",
    "ACC_FNM": "기    본    순    자    산",
    "ACC_UPP_CD": "310-31",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "341",
    "ACC_NM": "자본잉여금",
    "ACC_FNM": "Ⅱ. 자    본   잉  여  금",
    "ACC_UPP_CD": "32",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "34300",
    "ACC_NM": "고유목적사업준비금",
    "ACC_FNM": "고유목적사업준비금",
    "ACC_UPP_CD": "320-30",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "381",
    "ACC_NM": "자본조정",
    "ACC_FNM": "Ⅲ. 자    본     조    정",
    "ACC_UPP_CD": "33",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "397",
    "ACC_NM": "기타포괄손익누계액",
    "ACC_FNM": "Ⅳ. 기타 포괄  손익누계액",
    "ACC_UPP_CD": "34",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "39000",
    "ACC_NM": "지분법자본변동",
    "ACC_FNM": "지분법자본변동",
    "ACC_UPP_CD": "340-39",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "351",
    "ACC_NM": "이익잉여금",
    "ACC_FNM": "Ⅴ. 이    익   잉  여  금",
    "ACC_UPP_CD": "35",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "37600",
    "ACC_NM": "이월결손금",
    "ACC_FNM": "이월결손금",
    "ACC_UPP_CD": "350-76",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "37700",
    "ACC_NM": "미처분이익잉여금",
    "ACC_FNM": "미 처 분  이익  잉여금",
    "ACC_UPP_CD": "350-77",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "34100",
    "ACC_NM": "이월이익잉여금",
    "ACC_FNM": "이   월   이   익   잉   여   금",
    "ACC_UPP_CD": "350-78",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "37900",
    "ACC_NM": "당기순이익",
    "ACC_FNM": "(  당  기   순  이  익  )",
    "ACC_UPP_CD": "350-79",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "398",
    "ACC_NM": "자본총계",
    "ACC_FNM": "자      본       총      계",
    "ACC_UPP_CD": "3Y",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "399",
    "ACC_NM": "부채와자본총계",
    "ACC_FNM": "부  채    및    자 본 총 계",
    "ACC_UPP_CD": "3Z",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "4",
    "ACC_NM": "손익",
    "ACC_FNM": "손                       익",
    "ACC_UPP_CD": "4",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "401",
    "ACC_NM": "매출액",
    "ACC_FNM": "I.  매       출        액",
    "ACC_UPP_CD": "41",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "40200",
    "ACC_NM": "시출연금",
    "ACC_FNM": "시   출   연    금",
    "ACC_UPP_CD": "410-01",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "40300",
    "ACC_NM": "임대료수입",
    "ACC_FNM": "임  대  료  수  입",
    "ACC_UPP_CD": "410-02",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "40400",
    "ACC_NM": "대관료수입",
    "ACC_FNM": "대  관  료  수  입",
    "ACC_UPP_CD": "410-03",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "40500",
    "ACC_NM": "관리비수입",
    "ACC_FNM": "관  리  비  수  입",
    "ACC_UPP_CD": "410-04",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "40600",
    "ACC_NM": "국도비보조금",
    "ACC_FNM": "국 도 비  보 조 금",
    "ACC_UPP_CD": "410-05",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "40700",
    "ACC_NM": "시비보조금",
    "ACC_FNM": "시  비  보  조  금",
    "ACC_UPP_CD": "410-06",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "40900",
    "ACC_NM": "장비사용료",
    "ACC_FNM": "장  비  사  용  료",
    "ACC_UPP_CD": "410-07",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "41000",
    "ACC_NM": "기타수익금",
    "ACC_FNM": "기타수익금",
    "ACC_UPP_CD": "410-08",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "451",
    "ACC_NM": "매출원가",
    "ACC_FNM": "Ⅱ. 매    출     원    가",
    "ACC_UPP_CD": "42",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "800",
    "ACC_NM": "매출총이익",
    "ACC_FNM": "Ⅲ. 매   출    총  이  익",
    "ACC_UPP_CD": "42Y",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "801",
    "ACC_NM": "판매비와관리비",
    "ACC_FNM": "Ⅳ. 판 매 비 와  관 리 비",
    "ACC_UPP_CD": "43",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "80200",
    "ACC_NM": "직원급여",
    "ACC_FNM": "직    원      급    여",
    "ACC_UPP_CD": "430-02",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "80300",
    "ACC_NM": "상여금",
    "ACC_FNM": "상여금",
    "ACC_UPP_CD": "430-03",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "80800",
    "ACC_NM": "퇴직급여",
    "ACC_FNM": "퇴    직      급    여",
    "ACC_UPP_CD": "430-08",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "81100",
    "ACC_NM": "복리후생비",
    "ACC_FNM": "복   리   후   생   비",
    "ACC_UPP_CD": "430-11",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "81200",
    "ACC_NM": "여비교통비",
    "ACC_FNM": "여   비   교   통   비",
    "ACC_UPP_CD": "430-12",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "81400",
    "ACC_NM": "통신비",
    "ACC_FNM": "통        신        비",
    "ACC_UPP_CD": "430-14",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "81500",
    "ACC_NM": "수도광열비",
    "ACC_FNM": "수   도   광   열   비",
    "ACC_UPP_CD": "430-15",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "81700",
    "ACC_NM": "세금과공과금",
    "ACC_FNM": "세  금  과  공  과  금",
    "ACC_UPP_CD": "430-17",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "81800",
    "ACC_NM": "감가상각비",
    "ACC_FNM": "감   가   상   각   비",
    "ACC_UPP_CD": "430-18",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "81900",
    "ACC_NM": "지급임차료",
    "ACC_FNM": "지   급   임   차   료",
    "ACC_UPP_CD": "430-19",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "82000",
    "ACC_NM": "수선비",
    "ACC_FNM": "수        선        비",
    "ACC_UPP_CD": "430-20",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "82100",
    "ACC_NM": "보험료",
    "ACC_FNM": "보        험        료",
    "ACC_UPP_CD": "430-21",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "82200",
    "ACC_NM": "차량유지비",
    "ACC_FNM": "차   량   유   지   비",
    "ACC_UPP_CD": "430-22",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "82500",
    "ACC_NM": "교육훈련비",
    "ACC_FNM": "교   육   훈   련   비",
    "ACC_UPP_CD": "430-25",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "82600",
    "ACC_NM": "도서인쇄비",
    "ACC_FNM": "도   서   인   쇄   비",
    "ACC_UPP_CD": "430-26",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "82700",
    "ACC_NM": "회의운영비",
    "ACC_FNM": "회 의 운 영 비",
    "ACC_UPP_CD": "430-27",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "83000",
    "ACC_NM": "소모품비",
    "ACC_FNM": "소    모      품    비",
    "ACC_UPP_CD": "430-30",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "83100",
    "ACC_NM": "지급수수료",
    "ACC_FNM": "지   급   수   수   료",
    "ACC_UPP_CD": "430-31",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "83300",
    "ACC_NM": "광고선전비",
    "ACC_FNM": "광   고   선   전   비",
    "ACC_UPP_CD": "430-33",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "83700",
    "ACC_NM": "건물관리비",
    "ACC_FNM": "건 물 관 리 비",
    "ACC_UPP_CD": "430-37",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "84000",
    "ACC_NM": "무형자산상각",
    "ACC_FNM": "무형자산상각",
    "ACC_UPP_CD": "430-40",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "84900",
    "ACC_NM": "업무추진비",
    "ACC_FNM": "업 무 추 진 비",
    "ACC_UPP_CD": "430-49",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "85000",
    "ACC_NM": "관서업무비",
    "ACC_FNM": "관서업무비",
    "ACC_UPP_CD": "430-50",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "85100",
    "ACC_NM": "행사홍보비",
    "ACC_FNM": "행 사 홍 보 비",
    "ACC_UPP_CD": "430-51",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "85200",
    "ACC_NM": "자산취득비",
    "ACC_FNM": "자 산 취 득 비",
    "ACC_UPP_CD": "430-52",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "85300",
    "ACC_NM": "일반수용비",
    "ACC_FNM": "일반수용비",
    "ACC_UPP_CD": "430-53",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "85400",
    "ACC_NM": "연구용역비",
    "ACC_FNM": "연 구 용 역 비",
    "ACC_UPP_CD": "430-54",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "85500",
    "ACC_NM": "민간경상보조",
    "ACC_FNM": "민 간 경 상 보 조",
    "ACC_UPP_CD": "430-55",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "85700",
    "ACC_NM": "포상금",
    "ACC_FNM": "포 상 금",
    "ACC_UPP_CD": "430-57",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "85800",
    "ACC_NM": "기타보상금",
    "ACC_FNM": "기 타 보 상 금",
    "ACC_UPP_CD": "430-58",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "85900",
    "ACC_NM": "장기수선충당금전입",
    "ACC_FNM": "장기수선충당금전입",
    "ACC_UPP_CD": "430-59",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "900",
    "ACC_NM": "영업이익",
    "ACC_FNM": "Ⅴ. 영    업     이    익",
    "ACC_UPP_CD": "43Y",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "901",
    "ACC_NM": "영업외수익",
    "ACC_FNM": "Ⅵ. 영  업    외   수  익",
    "ACC_UPP_CD": "44",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "90100",
    "ACC_NM": "이자수익",
    "ACC_FNM": "이    자     수     익",
    "ACC_UPP_CD": "440-01",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "90200",
    "ACC_NM": "국비이자수익",
    "ACC_FNM": "국비이자수익",
    "ACC_UPP_CD": "440-02",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "90300",
    "ACC_NM": "배당금수익",
    "ACC_FNM": "배당금수익",
    "ACC_UPP_CD": "440-03",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "93000",
    "ACC_NM": "잡이익",
    "ACC_FNM": "잡        이        익",
    "ACC_UPP_CD": "440-30",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "777",
    "ACC_NM": "자 본 금",
    "ACC_FNM": "자본금",
    "ACC_UPP_CD": "444",
    "ACC_DCR_GB": "2"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "931",
    "ACC_NM": "영업외비용",
    "ACC_FNM": "Ⅶ. 영  업    외   비  용",
    "ACC_UPP_CD": "45",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "95200",
    "ACC_NM": "지분법손실",
    "ACC_FNM": "지분법손실",
    "ACC_UPP_CD": "450-52",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "997",
    "ACC_NM": "법인세차감전이익",
    "ACC_FNM": "Ⅷ. 법 인 세 차감전 이 익",
    "ACC_UPP_CD": "47Y",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "998",
    "ACC_NM": "법인세등",
    "ACC_FNM": "Ⅸ. 법    인    세     등",
    "ACC_UPP_CD": "480",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "99800",
    "ACC_NM": "법인세등",
    "ACC_FNM": "법    인      세    등",
    "ACC_UPP_CD": "480-01",
    "ACC_DCR_GB": "1"
  },
  {
    "ENT_CD": "200",
    "ACC_CD": "999",
    "ACC_NM": "당기순이익",
    "ACC_FNM": "Ⅹ. 당   기    순  이  익",
    "ACC_UPP_CD": "4Y",
    "ACC_DCR_GB": "1"
  }
];
